import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=57d47350&scoped=true"
import script from "./serve.vue?vue&type=script&lang=js"
export * from "./serve.vue?vue&type=script&lang=js"
import style0 from "pdfjs-dist/web/pdf_viewer.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "pdfvuer/dist/pdfvuer.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./serve.vue?vue&type=style&index=2&id=57d47350&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d47350",
  null
  
)

export default component.exports